import { useMemo, useState } from "react";
import "./contact.css";

const initialState = {
  name: "",
  email: "",
  message: "",
};

const emailRegex = /\S+@\S+\.\S+/;

export default function Contact() {
  const [values, setValues] = useState(initialState);
  const [touched, setTouched] = useState({});
  const [status, setStatus] = useState("idle"); // idle | submitting | success
  const [error, setError] = useState(null);

  const errors = useMemo(() => {
    const nextErrors = {};
    if (!values.name.trim()) {
      nextErrors.name = "Seu nome é obrigatório";
    }
    if (!values.email.trim()) {
      nextErrors.email = "Informe um e-mail";
    } else if (!emailRegex.test(values.email)) {
      nextErrors.email = "E-mail inválido";
    }
    if (!values.message.trim()) {
      nextErrors.message = "Conte um pouco sobre o projeto";
    }
    return nextErrors;
  }, [values]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleBlur = (event) => {
    const { name } = event.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setTouched({ name: true, email: true, message: true });
    setError(null);

    if (Object.keys(errors).length > 0) {
      return;
    }

    const subject = encodeURIComponent(
      `Contato - ${values.name.trim() || "Novo projeto"}`
    );

    const body = encodeURIComponent(
      `Olá Airton,\n\n${values.message.trim()}\n\nResponder para: ${values.email.trim()}`
    );

    const mailto = `mailto:airton_mio@hotmail.com?subject=${subject}&body=${body}`;

    if (typeof window === "undefined") {
      setError("Não foi possível abrir o cliente de e-mail neste ambiente.");
      setStatus("idle");
      return;
    }

    setStatus("submitting");

    window.location.href = mailto;

    setStatus("success");
    setValues(initialState);
    setTouched({});
  };

  return (
    <section
      id="contact"
      className="s-contact target-section"
      data-aos="fade-up"
    >
      <header className="section-header">
        <span className="section-eyebrow">Vamos conversar</span>
        <h2 className="section-title">Contato</h2>
        <p className="section-subtitle">
          Compartilhe a sua ideia ou desafio. Eu retorno rapidamente com os próximos passos.
        </p>
      </header>

      <div className="contact-card" data-state={status}>
        <form className="contact-form" onSubmit={handleSubmit} noValidate>
          <div className="contact-form__field">
            <label htmlFor="contact-name">Nome</label>
            <input
              id="contact-name"
              name="name"
              type="text"
              placeholder="Como podemos te chamar?"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              aria-invalid={Boolean(touched.name && errors.name)}
              aria-describedby={touched.name && errors.name ? "contact-name-error" : undefined}
              disabled={status === "submitting"}
            />
            {touched.name && errors.name && (
              <span id="contact-name-error" className="contact-form__error">
                {errors.name}
              </span>
            )}
          </div>

          <div className="contact-form__field">
            <label htmlFor="contact-email">E-mail</label>
            <input
              id="contact-email"
              name="email"
              type="email"
              placeholder="nome@empresa.com"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              aria-invalid={Boolean(touched.email && errors.email)}
              aria-describedby={touched.email && errors.email ? "contact-email-error" : undefined}
              disabled={status === "submitting"}
            />
            {touched.email && errors.email && (
              <span id="contact-email-error" className="contact-form__error">
                {errors.email}
              </span>
            )}
          </div>

          <div className="contact-form__field contact-form__field--full">
            <label htmlFor="contact-message">Mensagem</label>
            <textarea
              id="contact-message"
              name="message"
              placeholder="Conte sobre o projeto, objetivos ou prazo desejado."
              rows={5}
              value={values.message}
              onChange={handleChange}
              onBlur={handleBlur}
              aria-invalid={Boolean(touched.message && errors.message)}
              aria-describedby={touched.message && errors.message ? "contact-message-error" : undefined}
              disabled={status === "submitting"}
            />
            {touched.message && errors.message && (
              <span id="contact-message-error" className="contact-form__error">
                {errors.message}
              </span>
            )}
          </div>

          {error && <div className="contact-form__feedback contact-form__feedback--error">{error}</div>}

          <button
            type="submit"
            className="contact-form__submit"
            disabled={status === "submitting"}
          >
            <span className="contact-form__submit-text">
              {status === "submitting" ? "Enviando..." : "Enviar mensagem"}
            </span>
            <span className="contact-form__submit-glow" aria-hidden="true" />
          </button>
        </form>

          <div className="contact-card__success" role="status" aria-live="polite">
            <div className="contact-card__success-inner">
              <span className="contact-card__success-icon" aria-hidden="true">★</span>
              <h3>Mensagem recebida!</h3>
              <p>
                Seu aplicativo de e-mail foi aberto com os detalhes da conversa. Aguardo seu retorno para seguirmos com o projeto.
              </p>
            </div>
          </div>
      </div>
    </section>
  );
}
